import React, { memo } from 'react';

import DropDown from '../../helpers/DropDown';

import style from './style.module.css';

const ContactFullNameRowComponent = ({
  prefixId = 'newlpProfilePrefix',
  prefix,
  prefixes,
  root,
  onChange,
  suffix,
  children,
}) => (
  <div className={style.host}>
    <div className={style.prefix}>
      <DropDown
        buttonContent={prefix}
        className="btn-default btn-xs full-width"
        id={prefixId}
        name="prefix"
        onChange={onChange}
        root={root}
        deep
        isValuePicker
      >
        {prefixes}
      </DropDown>
    </div>
    <div className={style.fullName}>{children}</div>
    <div className={style.suffix}>{suffix}</div>
  </div>
);

/** Prefix dropdown, full name input (children) and suffix in one row of a contact popup. */
export const ContactFullNameRow = memo(ContactFullNameRowComponent);
